import React from 'react'

interface CategoryDotProps {
  active?: boolean
  className?: string
  size?: number
}

export function CategoryDot({ active = false, className = '', size = 20 }: CategoryDotProps) {
  const s = size
  const r = Math.floor(s * 0.3)
  return (
    <svg className={className} width={s} height={s} viewBox={`0 0 ${s} ${s}`} fill="none" aria-hidden>
      {active ? (
        <circle cx={s / 2} cy={s / 2} r={r} fill="currentColor" />
      ) : (
        <circle cx={s / 2} cy={s / 2} r={r} stroke="currentColor" strokeWidth={Math.max(1, s * 0.12)} fill="none" />
      )}
    </svg>
  )
}

export default CategoryDot
